import { useMeta, useContext } from '@nuxtjs/composition-api';
import { isEmpty } from 'lodash';
import { mergeHeadItems, insertIf } from '~/modules/common/utils/helpers';
import { getLinkMeta, getMetaOpenGraph, getMetaTwitter } from '~/modules/common/utils/metaUtils';
import {
  generateBreadcrumbSchema,
  generateNewsMediaOrganizationSchema,
  generateTagsSchema,
  generateWebPageSchema,
  generateWebsiteSchema,
  getSchemaHead,
} from '~/modules/common/utils/schemaUtils';
import { LINK_PROD } from '~/constants/config';

export function useTagMeta({ data = {}, feed = [], pagination = {}, customData = {} }) {
  const { i18n } = useContext();
  const { link } = getLinkMeta();
  const metaInit = [];
  useMeta(() => {
    let title = '';
    let description = '';
    if (!isEmpty(pagination.value)) {
      if (pagination.value.total_items < 5) {
        metaInit.push({ hid: 'robots', name: 'robots', content: 'noindex' });
      }
    }
    if (!isEmpty(data.value)) {
      description =
        (data.value.metaDescription || data.value.description) +
        (pagination.value.page > 1 ? ` - ${i18n.t('main.page')} ${pagination.value.page}` : '');
      title =
        data.value?.title ||
        `${data.value.name} ${i18n.t('main.news-post')}${
          pagination.value.page > 1 ? ` ${i18n.t('main.page')} ${pagination.value.page}` : ''
        } | ${i18n.t('meta.title')}`;
      if (data.value?.flags?.noindex) {
        metaInit.push({ hid: 'robots', name: 'robots', content: 'noindex' });
      }
    } else if (!isEmpty(customData)) {
      title = `${customData.title || customData.name} ${i18n.t('main.content-post')}${
        pagination.value.page > 1 ? ` ${i18n.t('main.page')} ${pagination.value.page}` : ''
      } | ${i18n.t('meta.title')}`;
      description =
        (customData.description || '') + (pagination.value.page > 1 ? ` - ${i18n.t('main.page')} ${pagination.value.page}` : '');
    }
    if (description.length) {
      metaInit.push({ hid: 'description', name: 'description', content: description });
    }
    const metaOpeGraph = getMetaOpenGraph({
      title,
      url: link[0].href,
      ...(description.length && { description }),
    });
    const metaTwitter = getMetaTwitter({ url: link[0].href, ...(description.length && { description }), title });
    const meta = [...metaInit, ...metaOpeGraph, ...metaTwitter];
    // tag schemas
    const websiteSchema = generateWebsiteSchema();
    const newsMediaOrganization = generateNewsMediaOrganizationSchema();
    const webPageSchema = generateWebPageSchema({ headline: title, description });
    let breadcrumbSchema = null;
    if (!isEmpty(data.value)) {
      const breadcrumb = [
        { url: LINK_PROD, name: i18n.t('main.homepage') },
        { url: `${LINK_PROD}${data.value.route}`, name: data.value.name },
      ];
      breadcrumbSchema = generateBreadcrumbSchema(breadcrumb);
    }
    let tagsSchema = null;
    if (!isEmpty(feed.value)) {
      tagsSchema = generateTagsSchema(feed.value);
    }
    return mergeHeadItems(
      getSchemaHead(websiteSchema),
      getSchemaHead(newsMediaOrganization),
      getSchemaHead(webPageSchema),
      ...insertIf(!isEmpty(data.value), getSchemaHead(breadcrumbSchema)),
      getSchemaHead(tagsSchema),
      { link },
      { meta },
      { title }
    );
  });
}
